import { ButtonStyles } from "../../types/styles";
import styled from "styled-components";
import Modal from "react-modal";
import { Button } from "../../components/index";

const customStyles: ReactModal.Styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  content: {
    top: '25%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '360px',
    padding: '0px'
  }
};

const ModalContent = styled.div`
  font-family: Roboto, system-ui, Avenir, sans-serif !important;
  line-height: 1.5;
  font-weight: 400;

  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const ModalTitle = styled.div`
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;
  font-size: 20px;
`;

const ModalBody = styled.div`
  padding: 15px;
`;

const ModalFooter = styled.div`
  border-top: 1px solid #e5e5e5;
  padding: 15px;
  text-align: right;
`;

export type ModalProps = {
  styles: ButtonStyles;
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  modalTitleText: string;
  modalBodyText: string;
  closeModalButtonText: string;
};

export const Title: React.FC<ModalProps> = ({
  styles,
  isModalOpen,
  setIsModalOpen,
  modalTitleText,
  modalBodyText,
  closeModalButtonText,
}) => {
  return (
        <Modal
          isOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
          style={customStyles}
        >
          <ModalContent>
            <ModalTitle>{modalTitleText}</ModalTitle>
            <ModalBody>{modalBodyText}</ModalBody>
            <ModalFooter>
              <Button 
                styles={styles}
                onClick={() => setIsModalOpen(false)}>{closeModalButtonText}
              </Button>
            </ModalFooter>
          </ModalContent>
      </Modal>
  );
};

export default Title;
